import { StaticImageData } from "next/image";
import amyImage from "@/app/(public)/shared/assets/team/amy.jpeg";
import annaImage from "@/app/(public)/shared/assets/team/anna.jpeg";
import benjiImage from "@/app/(public)/shared/assets/team/benji.jpeg";
import christinaImage from "@/app/(public)/shared/assets/team/christina.jpg";
import emilyImage from "@/app/(public)/shared/assets/team/emily.jpg";
import vinImage from "@/app/(public)/shared/assets/team/vin.png";
import hilaryImage from "@/app/(public)/shared/assets/team/hilary.jpeg";
import rachelImage from "@/app/(public)/shared/assets/team/rachel.jpeg";
import danielImage from "@/app/(public)/shared/assets/team/daniel.png";
import akshajImage from "@/app/(public)/shared/assets/team/akshaj.jpeg";
import rooImage from "@/app/(public)/shared/assets/team/roo.jpg";
import darielImage from "@/app/(public)/shared/assets/team/dariel.jpeg";
import sooImage from "@/app/(public)/shared/assets/team/soo.png";
import carleneImage from "@/app/(public)/shared/assets/team/carlene.png";
import michaelImage from "@/app/(public)/shared/assets/team/michael.jpg";

/** A Nowadays team member rendered on the public /team page. */
export interface TeamMember {
  id: number;
  name: string;
  role: string;
  image: StaticImageData;
  /** Flag emoji for the member's country; empty string hides the location row. */
  flag: string;
  /** Hometown shown next to the flag, e.g. "Dallas, TX"; empty string hides the row. */
  location: string;
  /** Profile URL opened when the card is activated. */
  linkedin: string;
}

/**
 * The team roster, in display order, shown on the public /team page.
 * Full-time staff come first, ordered by full-time start date. Contractors and pets follow.
 * Add a new full-time hire after the last full-time member, not at the end.
 */
export const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: "Anna Sun",
    role: "CEO",
    image: annaImage,
    flag: "🇺🇸",
    location: "Canton, MI",
    linkedin: "https://www.linkedin.com/in/annasun19/",
  },
  {
    id: 2,
    name: "Amy Yan",
    role: "COO",
    image: amyImage,
    flag: "🇺🇸",
    location: "Canton, MI",
    linkedin: "https://www.linkedin.com/in/amysunyan/",
  },
  {
    id: 3,
    name: "Vin Bui",
    role: "Engineer",
    image: vinImage,
    flag: "🇺🇸",
    location: "Dallas, TX",
    linkedin: "https://www.linkedin.com/in/vin-bui/",
  },
  {
    id: 4,
    name: "Christina Chen",
    role: "Chief of Staff",
    image: christinaImage,
    flag: "🇺🇸",
    location: "Bethlehem, PA",
    linkedin: "https://www.linkedin.com/in/chrichen/",
  },
  {
    id: 5,
    name: "Emily Zhang",
    role: "Product Engineer",
    image: emilyImage,
    flag: "🇺🇸",
    location: "Irvine, CA",
    linkedin: "https://www.linkedin.com/in/emilyzhang32/",
  },
  {
    id: 6,
    name: "Hilary Le",
    role: "Product Engineer",
    image: hilaryImage,
    flag: "🇺🇸",
    location: "Bay Area, CA",
    linkedin: "https://www.linkedin.com/in/hilaryle/",
  },
  {
    id: 7,
    name: "Rachel Alexander",
    role: "Event Operations",
    image: rachelImage,
    flag: "🇺🇸",
    location: "Plymouth, MN",
    linkedin: "https://www.linkedin.com/in/rachel-alexander-74a59888/",
  },
  {
    id: 8,
    name: "Dariel Gutierrez",
    role: "Product Engineer",
    image: darielImage,
    flag: "🇺🇸",
    location: "San Diego, CA",
    linkedin: "https://www.linkedin.com/in/dariel-gutierrez/",
  },
  {
    id: 9,
    name: "Soo Lee",
    role: "Product Engineer",
    image: sooImage,
    flag: "🇺🇸",
    location: "Boston, MA",
    linkedin: "https://www.linkedin.com/in/sooahnlee/",
  },
  {
    id: 10,
    name: "Carlene Sanchez",
    role: "Event Operations",
    image: carleneImage,
    flag: "🇺🇸",
    location: "Los Angeles, CA",
    linkedin: "https://www.linkedin.com/in/carlene-sanchez/",
  },
  {
    id: 11,
    name: "Michael Egan",
    role: "Event Operations",
    image: michaelImage,
    flag: "🇺🇸",
    location: "Los Angeles, CA",
    linkedin: "https://www.linkedin.com/in/michael-egan-4941a4145/",
  },
  {
    id: 12,
    name: "Daniel Sun",
    role: "Solutions Engineer",
    image: danielImage,
    flag: "🇺🇸",
    location: "San Diego, CA",
    linkedin: "https://www.linkedin.com/in/math-guy/",
  },
  {
    id: 13,
    name: "Akshaj Kadaveru",
    role: "Solutions Engineer",
    image: akshajImage,
    flag: "🇺🇸",
    location: "Fairfax, VA",
    linkedin: "https://www.linkedin.com/in/akshaj-kadaveru/",
  },
  {
    id: 14,
    name: "Benji",
    role: "Chief People Officer",
    image: benjiImage,
    flag: "🇺🇸",
    location: "Seattle, WA",
    linkedin: "https://www.linkedin.com/in/benji-yan-239a5a35a/",
  },
  {
    id: 15,
    name: "Roo",
    role: "Pawrty Planner",
    image: rooImage,
    flag: "🇺🇸",
    location: "Seattle, WA",
    linkedin: "https://www.nowadays.ai/",
  },
];
